<template>
  <div>
    <b-card no-body class="mb-3">
      <h6 slot="header" class="mb-0">
        <font-awesome-icon icon="cog" />ข้อมูลเพิ่มเติม
      </h6>

      <table class="table mb-0">
        <tbody>
          <tr>
            <td>
              <strong>ประเภทกิจกรรม</strong>
            </td>
            <td>{{ value.types }}</td>
          </tr>
          <tr>
            <td>
              <strong>อัตลักษณ์สถาบัน</strong>
              <p>อธิบายลักษณะกิจกรรมในโครงการที่ส่งเสริมอัตลักษณ์ของสถาบัน (กรอกเฉพาะอัตลักษณ์ที่เกี่ยวข้อง)</p>
            </td>
            <td>
              <strong>ซื่อสัตย์</strong><br>
              {{ value.characteristics[0] }}<br><br>
              <strong>ใฝ่รู้</strong><br>
              {{ value.characteristics[1] }}<br><br>
              <strong>สู้งาน</strong><br>
              {{ value.characteristics[2] }}
            </td>
          </tr>
          <tr>
            <td>
              <strong>ทักษะ</strong>
            </td>
            <td>
              <ul class="mb-0 pl-3">
                <li v-for="(type, index) in value.skills" :key="index">{{ type }}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>ยินยอมให้ประชาสัมพันธ์</strong>
            </td>
            <td class="align-middle">
              <b-form-checkbox v-model="value.isPromotingAllowed" :value="true" disabled>
                ยินยอมให้นำข้อมูลไปประชาสัมพันธ์ทั้งก่อนและหลังการจัดกิจกรรม
              </b-form-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <b-card no-body>
      <h6 slot="header" class="mb-0">
        <font-awesome-icon icon="cog" />การสะสมชั่วโมงกิจกรรม
      </h6>
      <div class="bg-warning px-3 py-2">
        <small>
          หากโครงการนี้มีการการสะสมชั่วโมงกิจกรรม หรือสร้างกิจกรรมบนระบบ KMITL Events จำเป็นต้องระบุข้อมูลส่วนนี้ให้ครบถ้วนและถูกต้อง
          เนื่องจากระบบจะไม่อนุญาตให้แก้ไขรายละเอียดบางส่วนในภายหลังได้
        </small>
      </div>
      <table class="table mb-0">
        <tbody>
          <tr>
            <td>
              <strong>วันที่จัดกิจกรรม</strong>
            </td>
            <td>{{ value.publicTimeframe }}</td>
          </tr>
          <tr>
            <td>
              <strong>การสะสมชั่วโมงกิจกรรม</strong>
            </td>
            <td>
              <ul class="mb-0 pl-3">
                <li>ประธานโครงการ {{ value.eventHoursCount.h }} ชม.</li>
                <li>เจ้าหน้าที่ {{ value.eventHoursCount.s }} ชม.</li>
                <li>ผู้เข้าร่วมโครงการ {{ value.eventHoursCount.p }} ชม.</li>
              </ul>
              <p class="mb-0">หมายเหตุ: จำนวนชั่วโมงกิจกรรม สูงสุดไม่เกิน 8 ชั่วโมง/วัน (ทุกตำแหน่ง)</p>
            </td>
          </tr>
          <tr>
            <td><strong>เงื่อนไขการแสดงทรานสคริปกิจกรรม (สำหรับผู้เข้าร่วมกิจกรรม)</strong></td>
            <td>
              <b-form-radio-group v-model="value.eventHoursPolicy" name="eventHoursPolicy" stacked disabled>
                <b-form-radio value="per_check_in">
                  เข้าร่วมกิจกรรมบางส่วน
                  <small class="form-text m-0 text-muted">
                    แสดงในทรานสคริปกิจกรรมเมื่อมีการเช็คอินเข้าร่วมกิจกรรมอย่างน้อย 1 ช่วง
                  </small>
                </b-form-radio>
                <b-form-radio value="whole_event" class="mt-2">
                  เข้าร่วมกิจกรรมครบถ้วน
                  <small class="form-text m-0 text-muted">
                    แสดงในทรานสคริปกิจกรรมเมื่อมีการเช็คอินเข้าร่วมกิจกรรมครบทุกช่วง
                  </small>
                </b-form-radio>
              </b-form-radio-group>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
  </div>
</template>

<script>

export default {
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 220px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
